import React from "react";
import './Header.css'
import {Nav, Navbar} from "react-bootstrap";
import {portfolioData} from "../../data/data";

// TODO: make header responsive for smaller screens - done

const Header = () =>
    <Navbar bg="light" expand="lg" id={'navbar'} fixed={'top'}>
        <Navbar.Brand href={'#intro'}>
            <h4 className={'brand mr-4'}>{portfolioData.name.noSpaces}</h4>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
                <Nav.Link href="#about" className={'pills header-menu-item'}>About</Nav.Link>
                <Nav.Link href="#skills" className={'pills header-menu-item'}>Skills</Nav.Link>
                <Nav.Link href="#projects" className={'pills header-menu-item'}>Projects</Nav.Link>
                <Nav.Link href="#contact" className={'pills header-menu-item'}>Contact</Nav.Link>
                <Nav.Link href={portfolioData.resume} className={'pills header-menu-item'}
                          style={{backgroundColor: '#2196f33d', color: '#2196f3'}}>Resume</Nav.Link>
            </Nav>
        </Navbar.Collapse>
    </Navbar>;
export default Header;